import React, { createContext, useContext } from 'react'

export interface LayoutContextType {
    selectedAnswer: number
    setSelectedAnswer: (value: number) => void
    isMobile: boolean
    logoURL: string | null
    loading: boolean
    communityhubname?: string
    isLoadingName: boolean
    pageTitle: string | null
    setPageTitle: (title: string | null) => void
    onBack: (() => void) | null
    setOnBack: (onBack: (() => void) | null) => void
    hideNav: boolean
    setHideNav: (hidden: boolean) => void
}

export const LayoutContext = createContext<LayoutContextType | undefined>(
    undefined
)

export function useLayoutContext(): LayoutContextType {
    const ctx = useContext(LayoutContext)
    if (!ctx) throw new Error('useLayoutContext must be used within Layout')
    return ctx
}
